import React from "react";
import Calendar from "react-calendar";
import moment from "moment";
import Button from "../../../UI/Button";
import { useDispatch, useSelector } from "react-redux";
import {
  setHoursWork,
  setSendData,
  setTechnician,
} from "../../../Store/Slice/scheduleSlice";
import useSetDatetime from "../../../Global/Api/Schedule/setDatetime";
import useGetTechniciansForMonth from "../../../Global/Api/Schedule/getTechniciansForMonth";
import useGetTimesInDay from "../../../Global/Api/Schedule/getTimesInDay";
import useGetTechniciansForJob from "../../../Global/Api/Schedule/getTechniciansForJob";
import {Link} from "react-router-dom";

export default function DatePicked({ setActivePicker }) {
  const dispatch = useDispatch();
  const setDatetime = useSetDatetime();
  const {
    tech: { date, time },
    hoursWork: timeList,
    disabledDates,
  } = useSelector((state) => state.rootReducer.scheduleSlice);
  const technician_locations = useSelector(
    (state) => state.rootReducer.scheduleSlice.technician_locations
  );
  const disabledButton = !(date && time);
  const timesInMonth = useGetTechniciansForMonth();
  const setTimes = useGetTimesInDay();
  const getTechnicians = useGetTechniciansForJob();

  const handleButton = () => {
    setActivePicker(false);
    dispatch(
      setTechnician({
        job_datetime: `${moment(date).format("YYYY-MM-DD")} ${time?.times}`,
      })
    );
    setDatetime.set(date, time);
    getTechnicians.get();
  };

  const handleTime = (item) => {
    dispatch(setTechnician({ time: { ...item, active: true } }));
    dispatch(
      setHoursWork([
        ...timeList?.map((time) => {
          let s = { ...time };
          s.active = s?.label === item.label;
          return s;
        }),
      ])
    );
    dispatch(setSendData({ job_datetime: item?.start }));
  };
  const disabledDatesListener = ({ date, view }) =>
    view === "month" &&
    disabledDates?.some(
      (disabledDate) =>
        date.getFullYear() === new Date(disabledDate).getFullYear() &&
        date.getMonth() === new Date(disabledDate).getMonth() &&
        date.getDate() === new Date(disabledDate).getDate()
    );

  return (
    <div className="date-picker">
      <div className="date-picker__date">
        <div className="date-picker__date-title">Pick the date</div>
        {disabledDates ? (
          <Calendar
            minDate={moment(new Date()).toDate()}
            value={JSON.parse(date)}
            onChange={(date) => {
              dispatch(
                setTechnician({ date: JSON.stringify(date), time: null, technician_id: null })
              );
              setTimes.get(date);
            }}
            onActiveStartDateChange={(date) => {
              timesInMonth.get(
                moment(date?.activeStartDate).format("YYYY"),
                moment(date?.activeStartDate).format("M")
              );
            }}
            tileDisabled={disabledDatesListener}
            selectRange={false}
          />
        ) : null}
      </div>
      <div className="date-picker__time">
        <div className="date-picker__time-title">
          {date
            ? moment(JSON.parse(date)).format("MMMM DD")
            : "Picked the Time"}
        </div>
        <div className="date-picker__time-list">

          {
            !technician_locations?.length ? (
              <div className="notifications__empty" style={{marginTop: '20px'}}>
                <p className="notifications__empty-text">There are currently no technicians in the area you chose.
                  Reach out to the Techsbook experts in the
                  <Link to={'/messaging'} style={{color: '#3772FF', textDecoration: 'underline', cursor: "pointer"}}> messages </Link>
                  section for support in covering your area.
                </p>
              </div>
            ) :
              timeList?.map((item, index) => (
                  <div
                    className={`date-picker__time-item ${
                      item?.active ? "active" : ""
                    }`}
                    id={index}
                    key={index}
                    onClick={() => handleTime(item)}
                  >
                    {item?.label}
                  </div>
                ))
          }
        </div>
        <div className="date-picker__button">
          <Button
            onClick={handleButton}
            text="Apply"
            disabled={disabledButton}
          />
        </div>
      </div>
    </div>
  );
}
